/**
 * Velire Auto-Advance Product Gallery
 * Automatically clicks the "next" control on the product media gallery
 * (Shopify Horizon's slideshow component) every 8 seconds, so images
 * rotate on their own — manual arrow/dot navigation keeps working normally.
 *
 * Confirmed selector (via browser inspection): .slideshow-control--next
 */
(function () {
  var ADVANCE_INTERVAL_MS = 8000;
  var timer = null;
  var resumeTimeout = null;

  function getNextButton() {
    return document.querySelector('.slideshow-control--next');
  }

  function advance() {
    var nextButton = getNextButton();
    if (nextButton) {
      nextButton.click();
    }
  }

  function startTimer() {
    stopTimer();
    timer = setInterval(advance, ADVANCE_INTERVAL_MS);
  }

  function stopTimer() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function init() {
    var nextButton = getNextButton();
    if (!nextButton) return; // No gallery/slideshow on this page — do nothing.

    startTimer();

    // Pause auto-advance while the person is actively interacting with the
    // gallery, then resume 8s after their last interaction.
    var gallery = nextButton.closest('[class*="media-gallery"], [class*="slideshow"]') || document;
    gallery.addEventListener('pointerdown', function () {
      stopTimer();
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(startTimer, ADVANCE_INTERVAL_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();